export default __webpack_public_path__ + "static/media/logo-duohotel.67d3f5f3.webp";